export default interface FaultsHistoryFilter {
  filterValueType: FaultsHistoryFilterValueType;
  values: string[];
}

export enum FaultsHistoryFilterValueType {
  Category = 'Category',
  FaultType = 'FaultType',
  DeviceType = 'DeviceType',
  SystemType = 'SystemType',
  GatewayType = 'GatewayType',
  Location = 'Location',
  CreatedOn = 'CreatedOn',
  Status = 'Status',
  ConnectorType = 'ConnectorType',
}
